import { Link } from 'react-router-dom';
import type { NewsArticle } from '@/types/news';
import SectionHeading from '@/components/feature/SectionHeading';
import { formatReadCount, getCategoryName } from '@/utils/news';

interface HotContentProps {
  articles: NewsArticle[];
}

export default function HotContent({ articles }: HotContentProps) {
  return (
    <section className="rounded-lg bg-background-100 border border-background-200 p-4 md:p-6">
      <SectionHeading title="热门内容" subtitle="按阅读量排序，大家都在看" icon="ri-fire-line" />
      {articles.length === 0 ? (
        <p className="text-sm text-foreground-500 py-6 text-center">暂无热门内容</p>
      ) : (
        <ol className="divide-y divide-background-200">
          {articles.map((article, i) => (
            <li key={article.id}>
              <Link to={`/detail/${article.id}`} className="group flex items-center gap-3 py-3 cursor-pointer">
                <span
                  className={`w-6 h-6 shrink-0 rounded-md flex items-center justify-center text-xs font-bold ${
                    i < 3 ? 'bg-accent-500 text-background-50' : 'bg-background-200 text-foreground-600'
                  }`}
                >
                  {i + 1}
                </span>
                <div className="min-w-0 flex-1">
                  <h3 className="text-sm text-foreground-800 group-hover:text-primary-600 transition-colors truncate">
                    {article.title}
                  </h3>
                  <div className="flex items-center gap-3 mt-1 text-xs text-foreground-500">
                    <span>{getCategoryName(article.category)}</span>
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-fire-line" />
                      {formatReadCount(article.readCount)}
                    </span>
                  </div>
                </div>
              </Link>
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}